<ion-app
	[class.scheduler-immersive]="schedulerImmersiveChrome"
	[class.scheduler-nav-revealed]="schedulerNavRevealed"
	(click)="onMainWindowClick($event);"
>
	<ng-container *ngIf="isEmbeddedSchedulerRoute; else defaultAppLayout">
		<ion-router-outlet></ion-router-outlet>
	</ng-container>

	<ng-template #defaultAppLayout>
		<ion-header class="app-header" *ngIf="!schedulerImmersiveChrome || schedulerNavRevealed">
			<ion-toolbar>
				<ion-item class="header-acc" detail="false" button (click)="goToCabinet()" onKeyUp="">
					<i class="icon icon-user"></i>
				</ion-item>
				<div class="logo" (click)="onLogoTap()">
					<img src="/assets/images/new logo.png" alt="mydj-logo" draggable="false" />
				</div>
				<div class="header-name" detail="false" style="position: absolute;right: 5px;top:5px;color: #0e4fa3;"
					*ngIf="currentUser && currentUser.isChildUser">
					{{currentUser.nick || currentUser.name}}
				</div>
				<div class="header-ny-btn" *ngIf="authenticated" (click)="toggleNyPanel($event);"><img
						src="/assets/images/happyNewYear.png" alt="ny"></div>
			</ion-toolbar>
		</ion-header>
		<div class="header-ny-panel" *ngIf="nyActive && authenticated && (!schedulerImmersiveChrome || schedulerNavRevealed)" (click)="onNyPanelClick($event);">
			<img src="/assets/images/happy_img_1.png" (click)="ny2($event);" alt="nyleft">
			<img src="/assets/images/happy_img_2.png" (click)="ny1($event);" alt="nyright">
		</div>
		<ion-router-outlet></ion-router-outlet>
		<ion-tabs class="app-tabs">
			<ion-tab-bar class="tab-bar" slot="bottom">
				<!-- A plain link, not window.open: the iOS web view ignores window.open, while a link
					 navigation in the app is handed to the OS by Cordova's allow-intent. -->
				<a class="tab-button ion-text-center" id="tab-button-tab4" href="https://wa.me/97236221404"
					[attr.target]="isCordova ? null : '_blank'" rel="noopener"
				>
					<div class="tab-button-inner">
						<i class="icon icon-whatsapp"></i>
						<ion-label>WhatsApp</ion-label>
					</div>
				</a>
				<ion-tab-button class="tab-button" *ngIf="authenticated && schedulerUnlocked" [routerLink]="['/scheduler']" routerLinkActive="tab-selected">
					<img class="tab-icon" src="/assets/images/icons/png-tmp/calendar.png" alt="Scheduler" />
					<ion-label>Scheduler</ion-label>
				</ion-tab-button>
				<ion-tab-button class="tab-button" tab="tab3" *ngIf="authenticated">
					<i class="icon icon-search"></i>
					<ion-label>Search</ion-label>
				</ion-tab-button>
				<ion-tab-button class="tab-button" tab="tab2" *ngIf="authenticated" (click)="playlistsClick($event)">
					<i class="icon icon-playlists"></i>
					<ion-label>Playlists</ion-label>
					<div class="badge-wrapper">
						<img src="../../assets/images/badge.gif" *ngIf="countOfBoldPlaylists > 0">
						<div class="countOfBoldPlaylists" *ngIf="countOfBoldPlaylists > 0">
							<span>{{countOfBoldPlaylists}}</span>
						</div>
					</div>
				</ion-tab-button>
				<ion-tab-button class="tab-button" tab="tab1" *ngIf="authenticated" (click)="playingNowClick($event)">
					<i class="icon icon-now-playing"></i>
					<ion-label>Now Playing</ion-label>
				</ion-tab-button>
			</ion-tab-bar>
		</ion-tabs>
	</ng-template>
</ion-app>

<div id="overlay-loading" [class]="loading">
	<div class="loader"></div>
</div>
<div id="overlay-notification" [innerHTML]="notification" [class]="notificationClass"></div>